module.exports = __webpack_public_path__ + "img/arrow-right-black.479156ce.svg";